import { ActionReducerMapBuilder } from '@reduxjs/toolkit'
import { PersonalizationEngineReportTypeEnum } from '@/enums'
import { PersonalizationEngineState } from '../models'

import { getAllPersonalizationEngineThunk } from '../thunks'

export const getAllPersonalizationEngineExtraReducer = (
  builder: ActionReducerMapBuilder<PersonalizationEngineState>,
) => {
  builder.addCase(
    getAllPersonalizationEngineThunk.pending,
    (state, { meta }) => {
      const { reportType } = meta.arg
      state.isLoadingGameCategory =
        reportType === PersonalizationEngineReportTypeEnum.CATEGORY
          ? true
          : state.isLoadingGameCategory
      state.isLoadingGameProvider =
        reportType === PersonalizationEngineReportTypeEnum.PROVIDER
          ? true
          : state.isLoadingGameProvider
    },
  )
  builder.addCase(
    getAllPersonalizationEngineThunk.fulfilled,
    (state, { payload, meta }) => {
      const { reportType } = meta.arg
      state.gameCategory =
        reportType === PersonalizationEngineReportTypeEnum.CATEGORY
          ? (payload.docs || []).map((doc: any) => ({
              ...doc,
              name: doc.game_category,
            }))
          : state.gameCategory
      state.gameProvider =
        reportType === PersonalizationEngineReportTypeEnum.PROVIDER
          ? (payload.docs || []).map((doc: any) => ({
              ...doc,
              name: doc.game_provider,
            }))
          : state.gameProvider
      state.isLoadingGameCategory =
        reportType === PersonalizationEngineReportTypeEnum.CATEGORY
          ? false
          : state.isLoadingGameCategory
      state.isLoadingGameProvider =
        reportType === PersonalizationEngineReportTypeEnum.PROVIDER
          ? false
          : state.isLoadingGameProvider
    },
  )
}
